import { SearchIcon } from '@chakra-ui/icons';
import {
  Box,
  Center,
  Flex,
  InputGroup,
  InputRightElement,
  Input,
  Spinner,
  useColorModeValue,
  Hide,
} from '@chakra-ui/react';
import PropTypes, { object } from 'prop-types';
import { useState } from 'react';
import DataTable from 'react-data-table-component';

function UserTable({ users, columns, onSelectRowHandler, children }) {
  const [searchText, setSearchText] = useState('');

  const filteredUsers = users.filter(
    (item) =>
      item.label.toLowerCase().includes(searchText.toLowerCase()) ||
      item.value.toLowerCase().includes(searchText.toLowerCase())
  );

  const handleSearchTextChange = (e) => {
    setSearchText(e.target.value);
  };

  return (
    <Box mt={5} w="100%" p={4} color="gray.500" borderWidth="1px">
      <Flex align="end">
        <InputGroup>
          <InputRightElement pointerEvents="none">
            <SearchIcon color="gray.300" />
          </InputRightElement>
          <Input
            value={searchText}
            onChange={handleSearchTextChange}
            name="query"
            placeholder="Search by name"
          />
        </InputGroup>
      </Flex>

      {children}

      <DataTable
        theme={useColorModeValue('default', 'dark')}
        columns={columns}
        data={filteredUsers}
        progressComponent={
          <Center my={10}>
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="blue.500"
              size="xl"
            />
          </Center>
        }
        onSelectedRowsChange={({ selectedRows }) =>
          onSelectRowHandler(selectedRows)
        }
        selectableRows
        pagination
      />
    </Box>
  );
}

UserTable.defaultProps = {
  users: [],
  children: <Hide>BLANK</Hide>,
};

UserTable.propTypes = {
  users: PropTypes.arrayOf(object),
  columns: PropTypes.arrayOf(object).isRequired,
  onSelectRowHandler: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default UserTable;
